import { Button, Dialog, DialogContent } from "@mui/material";
import React, { memo } from "react";

import { Props } from "./interfaces";
import DialogActions from "../DialogActions/DialogActions";
import DialogTitle from "../DialogTitle/DialogTitle";

import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";

const CustomConfirmationChangesDialog = ({
  open,
  loading,
  title,
  children,
  handleCancel,
  actionsAndHandlers,
  maxWidth,
  customCancelName,
}: Props) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={maxWidth ?? "md"}
    >
      <LoadingOverlay loading={loading}>
        <DialogTitle
          title={title}
          handleClose={handleCancel}
        />
        <DialogContent>{children}</DialogContent>
        <DialogActions
          handleCancel={handleCancel}
          useGoback={true}
          {...(customCancelName && { customCancelName })}
        >
          {actionsAndHandlers.length > 0 &&
            actionsAndHandlers.map(({ action, buttonVariant, handler, customButtonStyle, disabled }, idx) => (
              <Button
                key={idx}
                style={{ ...customButtonStyle }}
                variant={buttonVariant}
                onClick={(event) => {
                  event.preventDefault();
                  handler();
                }}
                disabled={disabled}
              >
                {action}
              </Button>
            ))}
        </DialogActions>
      </LoadingOverlay>
    </Dialog>
  );
};

export default memo(CustomConfirmationChangesDialog);
